import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { PlatformModule } from '@app/platform.module';
import { TranslateModule } from '@ngx-translate/core';
import { TimeOffService } from '@time-off-v3/services';
import { Employee } from '@models/employee/employee.model';
import { AuthService, NotifyService } from '@app/services';
import { TranslatableKey } from '@app/types/translatable.type';

@Component({
    selector: 'app-general-settings-card',
    standalone: true,
    imports: [TranslateModule, PlatformModule, CommonModule],
    templateUrl: './general-settings-card.template.html',
    styleUrls: ['./general-settings-card.style.scss'],
})
export class GeneralSettingsCardComponent implements OnInit {
    @Input() timeOffVisibility = false;
    @Input() timeOffBalanceDateToday = false;

    isLoading = false;
    approver: TranslatableKey = 'time-off-v3.allActiveAdmins';

    constructor(
        private readonly auth: AuthService,
        private readonly notify: NotifyService,
        private readonly timeOffService: TimeOffService
    ) {}

    async ngOnInit(): Promise<void> {
        this.isLoading = true;

        try {
            const [[activeAdmins], timeOffBackupApprover] = await Promise.all([
                Employee.param('company', this.auth.company.id)
                    .orderBy('firstName', 'ASC')
                    .where('adminOnly', true)
                    .all(),
                this.timeOffService.getTimeOffBackupApprover(),
            ]);

            const backupApproverId = timeOffBackupApprover.approverId ?? 0;

            if (backupApproverId) {
                this.approver = activeAdmins.find((admin) => admin.id === backupApproverId)?.fullName;
            }
        } catch (error) {
            this.notify.error(error);
        } finally {
            this.isLoading = false;
        }
    }
}
